import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/user-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-030afefe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "",
  class: ""
}
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = {
  class: "profile-data d-flex align-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_4 = { class: "name-and-role d-flex flex-column" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "role" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer",
  src: _imports_0,
  alt: "avatar"
}, null, -1))
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.fullName), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.email), 1)
            ]),
            _hoisted_7
          ]),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: { name: 'user-profile' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" User Profile ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent","stop"]))
              }, "Logout")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}